import {
  DvTextCellEditor,
  DvToolbarAction,
  DvToolbarActionEvent,
} from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { AttachmentsService } from '@shared/services/attachments.service';
import { ColDef, IRowNode } from 'ag-grid-community';
import { take, tap } from 'rxjs';
import { AssetPictureDocumentDto } from './interfaces';

@Injectable()
export class AssetPictureDocumentGridService {
  private attachmentsService = inject(AttachmentsService);

  getColumnDefs(
    radioButtonChangeFn: (selectedNodeId?: number) => void,
    canEdit: boolean
  ): ColDef<AssetPictureDocumentDto>[] {
    return [
      {
        colId: 'DocumentID',
        headerName: 'Grid.Id',
        type: [ColumnType.Id],
        field: 'DocumentID',
        hide: true,
      },
      {
        headerName: 'PictureDocumentGrid.IsDefault',
        field: 'IsDefault',
        type: [ColumnType.RadioButton],
        width: 100,
        flex: 2,
        cellRendererParams: {
          disabledFn: (node?: IRowNode) =>
            !canEdit || !this.attachmentsService.isImage(node?.data?.FileName),
          check: (node: IRowNode) => {
            node.setDataValue('IsDefault', true);
            radioButtonChangeFn(node.data?.DocumentID);
          },
          unCheck: (node: IRowNode) => {
            node.setDataValue('IsDefault', false);
            radioButtonChangeFn();
          },
          filter: 'agSetColumnFilter',
        },
      },
      {
        headerName: 'PictureDocumentGrid.DocumentThumbnail',
        field: 'DocumentThumbnail',
        type: [ColumnType.Thumbnail],
        enableRowGroup: false,
        width: 100,
        flex: 4,
      },
      {
        headerName: 'PictureDocumentGrid.DocumentDescription',
        field: 'DocumentDescription',
        type: [ColumnType.Text],
        cellEditor: DvTextCellEditor,
        editable: true,
      },
      {
        field: 'CreatedTime',
        headerName: 'PictureDocumentGrid.CreatedTime',
        type: [ColumnType.DateTime],
      },
      {
        headerName: 'PictureDocumentGrid.DocumentFileName',
        field: 'FileName',
        type: [ColumnType.Text],
        flex: 4,
      },
    ];
  }

  getToolbarActions(
    uploadFileFn: () => void,
    deleteFileFn: (event?: DvToolbarActionEvent) => void
  ): DvToolbarAction[] {
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'download',
        tooltipKey: 'Grid.Download',
        clickFn: ({ api }) => {
          this.attachmentsService
            .getAttachmentUrl(api.getSelectedNodes()[0].data.DocumentID, false)
            .pipe(
              take(1),
              tap(url => this.attachmentsService.downloadAttachment(url))
            )
            .subscribe();
        },
      },
      {
        icon: 'delete',
        clickFn: (event: DvToolbarActionEvent) => {
          deleteFileFn(event);
        },
        disabled: true,
        tooltipKey: 'Grid.Delete',
      },
      {
        icon: 'add_box',
        clickFn: uploadFileFn,
        disabled: false,
        tooltipKey: 'Grid.Add',
      },
    ];
  }
}
